/**
 * Class to print stuff to be showed to the user.
 */
export class PrettyPrinter {

    /**
     * String representation of a number.
     *
     * @param {number} f the number to be displayed.
     * @param {number} precision how many decimals to show (defaults to 0).
     * @param {string} unit the unit of measure (optional).
     * @returns {string} the number in the user locale, for example "1,234.56 L".
     */
    public static number(f: number, precision: number = 0, unit?: string): string {
        let str = parseFloat(f.toFixed(precision)).toLocaleString();
        if (unit) {
            str += " " + unit;
        }
        return str;
    }

    /**
     * String representation of a sales quantity.
     * The precision is determined by the amount (0, 1, 2 decimals).
     *
     * @param {number} f the number to be displayed.
     * @param {string} unit the unit of measure (optional).
     * @returns {string} the number in the user locale, for example "64.56 L".
     */
    public static salesQuantity(f: number, unit?: string): string {
        if (f < 100) {
            return PrettyPrinter.number(f, 2, unit);
        }
        if (f < 1000) {
            return PrettyPrinter.number(f, 1, unit);
        }
        return PrettyPrinter.number(f, 0, unit);
    }

}
